const fn = (v, factor) => Math.min(v + (factor * (255 - v)), 255);

export const tint = (c, c1, strength=.25) => {
    c.r = fn(c.r, c1.r/255 * strength);
    c.g = fn(c.g, c1.g/255 * strength);
    c.b = fn(c.b, c1.b/255 * strength);
};
